<template>
	<div class="chain">
		
		<!-- 头部 -->
		<zmlmenupage cn-name='产业生态链' en-name='Shipping Ecological Chain'></zmlmenupage>
		
		<zmlpagebanner
		banner-img='static/img/proBanner.png' 
		banner-text='货运江湖，一键启航！' 
		cn-name='产品中心' 
		en-name='Product Center'>
		</zmlpagebanner>
		
		<div class="chain-text">
			<div class="chain-text-title">
				<p>产业<span>生态链</span></p>
			</div>
			<div class="chain-text-text">
				<p>一个属于物流运输的崭新时代</p>
				<p>划破薄雾，即将登场</p>
				<p>互联网+物流大产业生态链，给予未来更多可能</p>
				<p>想象未来，不如走向未来</p>
			</div>
			<div class="chain-text-icons">
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-1.png" alt="" width="128"/>
					<p>保险</p>
				</div>
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-2.png" alt="" width="128"/>
					<p>船舶维修</p>
				</div>
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-3.png" alt="" width="128"/>
					<p>多式联运</p>
				</div>
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-4.png" alt="" width="128"/>
					<p>加油</p>
				</div>
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-5.png" alt="" width="128"/>
					<p>结算支付</p>
				</div>
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-6.png" alt="" width="128"/>
					<p>金融贷款</p>
				</div>
				<div class="chain-text-icons-item">
					<img src="../../static/img/industry-7.png" alt="" width="128"/>
					<p style="white-space:nowrap">码头贸易生态链</p>
				</div>
			</div>
		</div>
		
		<div class="chain-imgs">
			<img src="../../static/img/stl2.png" alt="">
			
			<img src="../../static/img/stlllll.png" alt="">
		</div>
		
		<div class="chain-content">
			<div class="kuang"></div>
			<div class="chain-content-text">
				<div>
					<p>用5G重新建构</p>
					<p>物流运输产业生态链</p>
				</div>
				<div>
					<p>打通商业闭环，链接服务体系</p>
					<p>构建一个数智化综合物流服务平台</p>
					<p>依托互联网技术，引领行业变革创新</p>
					<p>为物流业带来便捷、高效的全新生态</p>
				</div>
			</div>
		</div>
		<gototop></gototop>
	</div>
</template>
<script>
  export default{
	namne:'chain',
    data(){
      return{

      }
    }
  }
</script>
<style scoped="scoped">
.chain-text{
	text-align: center;
	overflow: hidden;
}
.chain-text-title{
	font-size: 54px;
	margin-top: 105px;
}
.chain-text-title span{
	color: #127BFD;
}
.chain-text-text{
	font-size: 20px;
	line-height: 36px;
	padding-top: 40px;
}
.chain-text-icons{
	padding: 20px 0;
	display: flex;
	justify-content: space-around;
}
.chain-text-icons-item{
	width: 128px;
	/* margin: 0  50px; */
}
.chain-text-icons-item p{
	font-size: 20px;
}
.chain-imgs{
	width: 100%;
	height: 323px;
	overflow: hidden;
	display: flex;
	justify-content: center;
	align-items: flex-start;
}

.chain-imgs img:nth-of-type(2){
	display: none;
}

.chain-content{
	width: 100%;
	height: 788px;
	overflow: hidden;
	background: url(../../static/img/stl1.png) no-repeat center;
	background-size: cover;
	position: relative;
	background-attachment: fixed;
}
.kuang{
	position: absolute;
	z-index: 1;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	width:155px;
	height:422px;
	border:6px solid rgba(18,123,253,1);
}
.chain-content-text{
	position: absolute;
	z-index: 2;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	color: #fff;
	text-align: center;
	font-size: 28px;
}
.chain-content-text div{
	margin: 30px 0;
}
.chain-content-text div p{
	line-height: 44px;
}

@media only screen and (max-width: 750px){
	.chain-text-title{
		font-size: 40px;
		margin-top: 50px;
		font-weight: bold;
	}
	.chain-text-text{
		font-size: 14px;
		font-weight: bold;
		line-height: 22px;
	}
	.chain-text-icons{
		flex-wrap: wrap;
	}
	.chain-text-icons-item{
		width: 64px;
		margin: 10px 30px;
	}
	.chain-text-icons-item img{
		width: 100% !important;
	}
	.chain-text-icons-item p{
		font-size: 12px;
		font-weight: bold;
	}
	.chain-imgs{
		height: auto;
	}
	.chain-imgs img{
		width: 100%;
	}
	.chain-imgs img:nth-of-type(1){
		display: none;
	}
	.chain-imgs img:nth-of-type(2){
		display: block;
	}
	.kuang{
		width: 30%;
		height: 40%;
		border: 3px solid rgba(18,123,253,1);
	}
	.chain-content-text{
		font-size: 14px;
	}
	.chain-content-text div p{
		line-height: 22px;
		white-space: nowrap;
	}
	.chain-content{
		height: 630px;
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/chain.vue